<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}">
  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="flex">
      <div class="rirekisho-box1">
        <div class="rirekisho-header">
          <div class="title">이력서</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 현재
          </div>
        </div>
        <div class="rirekisho-profile"
             :data-highlight="highlightMessage"
             @click="goCardTo('profile')"
             :class="highLightClass('profile')">
<!--          <div class="ruby flex">-->
<!--            <div class="label">ふりがな</div>-->
<!--            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>-->
<!--          </div>-->
          <div class="name flex">
            <div class="label">이름</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc flex">
            <div class="birthday" :style="formatData.selFontStyle">
              <span class="year">{{ basicData.birthYear }}</span>年 <span class="month">{{ basicData.birthMonth }}</span>월 <span class="day">{{ basicData.birthDay }}</span>일생（만 <span class="age">{{ age }}</span> 세）
            </div>

            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">남</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">여</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-photo"
           :data-highlight="highlightMessage"
           @click="goCardTo('id-photo')"
           :class="highLightClass('id-photo')">
        <div v-if="basicData.idPhotoSrc">
          <img :src="basicData.idPhotoSrc"
               alt="증명사진">
        </div>
        <div v-else>
          <div class="rirekisho-photo-inner">
            <p>증명사진
              <br>세로 36mm&#12316;40mm
              <br>가로 24mm&#12316;30mm
              <br>가슴위
              <br>뒷면접착
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             :data-highlight="highlightMessage"
             @click="goCardTo('address')"
             :class="highLightClass('address')">
<!--          <div class="ruby flex">-->
<!--            <div class="label">ふりがな</div>-->
<!--            <div class="input" ref="addressFurigana"-->
<!--                 :class="classObject.addressFurigana" :style="formatData.selFontStyle">{{ basicData.addressFurigana }}</div>-->
<!--          </div>-->
          <div class="address flex">
            <div class="label">현 주소</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}}
{{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             :data-highlight="highlightMessage"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">전화</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
      <div class="contact-information contact-sub flex">
        <div class="contact-information-address"
             @click="goCardTo('address')"
             :class="highLightClass('address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input"
                 :class="{'font-size-sm': ($formLib.charCount(basicData.contactAddressFurigana) > 59) }" :style="formatData.selFontStyle">{{ basicData.contactAddressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">연락처</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.contactPostNumber) }}</div>
              <div class="comment">(현주소 이외에 연락을 원하는 경우에만 입력)</div>
              <pre :style="formatData.selFontStyle">{{ basicData.contactAddress1 }}
{{ basicData.contactAddress2 }}</pre>
              <div class="care-of"
                   v-if="basicData.contactCareOf" :style="formatData.selFontStyle">{{ basicData.contactCareOf }} </div>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">전화</div>
            <div class="input" :style="formatData.selFontStyle">{{ contactTel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.contactEmail }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-table rirekisho-new-history-1"
         :data-highlight="highlightMessage"
         @click="goCardTo('edu-history')"
         :class="highLightClass(['edu-history','job-history'])">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>학력</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable4New"
              v-bind:class="item.classObject"
              v-if="index < 10"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-table rirekisho-skill"
         :data-highlight="highlightMessage"
         @click="goCardTo('license-history')"
         :class="highLightClass('license-history')">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>면허・자격증</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 5"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-02'">
    <div class="rirekisho-pr-slim">
      <div class="rirekisho-pr-reason-new-stg"
        v-if="!formatData.notDisplayRecommend"
           @click="$eventHub.$emit('go-card-to', 'reasonNew')">
        <div class="label">자기PR·세미나연구·특기과목·지원동기·특기·어필포인트 등</div>
        <div class="input">
          <pre ref="reasonNew"
               :class="classObject.reasonNew" :style="formatData.selFontStyle">{{ formatData.reasonNew }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-reason-new"
        v-else
           @click="$eventHub.$emit('go-card-to', 'reasonNew')">
        <div class="label">자기PR·세미나연구·특기과목·지원동기·특기·어필포인트 등</div>
        <div class="input">
          <pre ref="reasonNew"
               :class="classObject.reasonNew" :style="formatData.selFontStyle">{{ formatData.reasonNew }}</pre>
        </div>
      </div>
      <div class="rirekisho-qr-introd-new"
          v-if="!formatData.notDisplayRecommend"
           @click="$eventHub.$emit('go-card-to', 'others')">
        <div class="label">소개・추천</div>
        <div style="height:100%;text-align:center;">
          <a :href="qr_link"><img :src="qr_image" style="height:80%;text-align:center;" /></a>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
           @click="$eventHub.$emit('go-card-to', 'others')">
        <div class="time">
          <div class="label">통근시간</div>
          <div class="input text-right" v-if="formatData.commuteHours || formatData.commuteMinutes" :style="formatData.selFontStyle">약 <template v-if="formatData.commuteHours"><span>{{ formatData.commuteHours }}</span> 시간</template> <template v-if="formatData.commuteMinutes"><span>{{ formatData.commuteMinutes }}</span> 분</template></div>
        </div>
        <div class="family">
          <div class="label">부양가족 수(배우자 제외)</div>
          <div class="input text-right" :style="formatData.selFontStyle"><span>{{ formatData.spouseNumber }}</span> 명</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">배우자</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.hasSpouse}">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.hasSpouse}">무</span></div>
          </div>
          <div class="support">
            <div class="label">배우자의 부양 의무</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport}">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport}">무</span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-new-hope"
         :data-highlight="highlightMessage"
         @click="goCardTo('requests')"
         :class="highLightClass('requests')">
      <div class="label">본인희망란(급여·직종·근무시간·근무지·기타에 대해 희망이 있으면 기입)</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoPreview',
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 11,
      maxLicenseRows: 5,
      qr_image: '',
      qr_link: '',
      textareaMaxHeights: {
        reason: 710,
        reasonNew: 710,
        request: 100
      }
    }
  },
  created: function () {
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  }
}
</script>
